import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './marketplace-block.module.css';

interface MarketplaceBlockProps {
  className?: string;
  title: ReactNode,
  children: ReactNode,
}

const MarketplaceBlock = ({ className, title, children }: MarketplaceBlockProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.description}>
        {children}
      </div>
    </div>
  )
};

export default MarketplaceBlock;
